import React from 'react';

interface StackProps {
  horizontal?: boolean;
  gap?: number;
  children: React.ReactNode;
}

export const Stack = ({ horizontal, gap = 0, children }: StackProps) => {
  const flexDirection = horizontal ? 'flex-row' : 'flex-col';
  const gapClass = `gap-${gap}`;

  return <div className={`flex ${flexDirection} ${gapClass}`}>{children}</div>;
};
